import React, { useState } from "react";
import styled from "styled-components";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { SubTitle } from "../Styles";

const CollapsibleWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.branding.borderColor};
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: auto;
  }
`;

const HeaderButton = styled.button`
  /* border-radius: 8px; */
  display: flex;
  background-color: ${({ theme }) => theme.branding.textColor};
  font-size: 16px;
  padding: 10px;
  font-weight: 800;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
`;

const Body = styled.div`
  padding: 0px 20px;
  overflow: hidden;
  height: 0;
  transition: height 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.branding.color};

  &.isOpen {
    height: auto;
    visibility: visible;
  }

  &.isClosed {
    visibility: hidden;
    padding: 0px 10px;
  }
`;

function Collapsible({ title, children }) {
  const [isOpen, setIsOpen] = useState(true);

  const toggleBody = () => {
    setIsOpen(!isOpen);
  };

  return (
    <CollapsibleWrapper>
      <HeaderButton
        aria-expanded={isOpen}
        aria-controls="collapsible-content"
        onClick={toggleBody}
      >
        {isOpen ? <FaCaretUp /> : <FaCaretDown />}{" "}
        <SubTitle style={{ paddingLeft: "5px" }}>{title}</SubTitle>
      </HeaderButton>
      <Body className={isOpen ? "isOpen" : "isClosed"}>{children}</Body>
    </CollapsibleWrapper>
  );
}

export default Collapsible;
